import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54cb89f7&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54cb89f7', component.options)
    } else {
      api.reload('54cb89f7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=54cb89f7&", function () {
      api.rerender('54cb89f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/login/index.vue"
export default component.exports